module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more darker moved-right"
  }, [_c('h6', {
    staticClass: "d-flex align-items-center dark pointer m-2 d-flex align-items-center",
    staticStyle: {
      "padding-bottom": "0.0px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v("Go to Filters")])]), _vm._v(" "), (_vm.getIsloadingSelectedEvent) ? _c('div', {
    staticClass: "p-3 text-center"
  }, [_c('loader')], 1) : (_vm.event) ? _c('div', {
    staticClass: "relative my-3 mx-1 border-right-light border-bottom-light border-left-light"
  }, [_c('div', {
    staticClass: "box border-top-light shadowless"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.event.nameAlias) ? _c('div', [(_vm.product) ? _c('span', [_vm._v(_vm._s(_vm.product.name))]) : _vm._e(), _vm._v(" "), (_vm.product) ? _c('h3', [_vm._v(_vm._s(_vm.event.nameAlias))]) : _vm._e()]) : (_vm.product) ? _c('h3', [_vm._v(_vm._s(_vm.product.name))]) : _vm._e(), _vm._v(" "), _c('links', {
    attrs: {
      "event": _vm.event
    }
  })], 1)]), _vm._v(" "), _c('tabs-place', {
    attrs: {
      "event": _vm.event
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-8e84a792", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e84a792"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventMore.vue
// module id = 1682
// module chunks = 0